import { render, staticRenderFns } from "./view3dPage.vue?vue&type=template&id=3d79a1ae&scoped=true"
import script from "./view3dPage.vue?vue&type=script&lang=js"
export * from "./view3dPage.vue?vue&type=script&lang=js"
import style0 from "./view3dPage.vue?vue&type=style&index=0&id=3d79a1ae&prod&lang=scss&scoped=true"
import style1 from "./view3dPage.vue?vue&type=style&index=1&id=3d79a1ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d79a1ae",
  null
  
)

export default component.exports